import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import {
  GoogleMap,
  Marker,
  InfoWindow,
  useJsApiLoader
} from '@react-google-maps/api';

import styles from '../../../../helpers/snazzymaps';

const Map = ({
  mapId,
  apiKey,
  defaultLocation,
  filters,
  pins,
  selectedPin,
  onPinSelect
}) => {
  const { isLoaded } = useJsApiLoader({
    id: mapId,
    googleMapsApiKey: apiKey
  });

  return isLoaded ? (
    <GoogleMap
      mapContainerClassName="interactive-map-module__map"
      center={defaultLocation}
      zoom={12.5}
      onClick={() => onPinSelect(null)}
      options={{
        styles,
        maxZoom: 18,
        streetViewControl: false,
        ignoredPins: ['all']
      }}
    >
      {pins
        ?.filter(pin =>
          filters.some(
            filter => filter.filterId === pin.filterId && filter.selected
          )
        )
        .map(pin => (
          <Marker
            key={pin.filterId}
            position={pin.geo}
            icon={pin.icon}
            onClick={() => onPinSelect(pin)}
          />
        ))}
      {!!selectedPin && (
        <InfoWindow
          position={selectedPin.geo}
          options={{ alignBottom: true, maxWidth: 350 }}
          onCloseClick={() => onPinSelect(null)}
        >
          <div>
            <p className="interactive-map-module__location-name">
              {selectedPin.name}
            </p>
            {!!selectedPin.description && (
              <p className="interactive-map-module__location-description">
                {selectedPin.description}
              </p>
            )}
            {!!selectedPin.linkUrl && (
              <a
                href={selectedPin.linkUrl}
                target={selectedPin.linkTarget}
                className="btn btn--primary btn--small"
              >
                {selectedPin.linkText}
              </a>
            )}
          </div>
        </InfoWindow>
      )}
    </GoogleMap>
  ) : (
    <></>
  );
};

Map.propTypes = {
  apiKey: PropTypes.string.isRequired,
  mapId: PropTypes.string.isRequired,
  defaultLocation: PropTypes.object.isRequired,
  filters: PropTypes.array,
  pins: PropTypes.array,
  selectedPin: PropTypes.object,
  onPinSelect: PropTypes.func.isRequired
};

export default Map;
